import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { db, storage } from '../firebase';
import { ref as dbRef, push } from "firebase/database";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { translateToMarathi } from '../utils/translationUtils';

const SocietyLotteryRegistration = () => {
  const [formData, setFormData] = useState({
    societyName: '',
    societyAddress: '',
    registrationClass: '',
    registrationNo: '',
    taluka: '',
    licenseStartDate: '',
    licenseEndDate: '',
    aadharNo: '',
    panNo: '',
    gstNo: '',
    chairmanName: '',
    chairmanWhatsapp: '',
    chairmanAddress: '',
    declaration: false
  });

  const [selectedFiles, setSelectedFiles] = useState({
    aadharFile: null,
    panFile: null,
    gstFile: null,
    classificationFile: null
  });

  const [uploading, setUploading] = useState(false);
  const translationTimeoutRef = React.useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }));

    // Trigger translation ONLY for specific fields
    const translationFields = ['societyName', 'societyAddress', 'chairmanName', 'chairmanAddress'];
    if (translationFields.includes(name)) {
      if (translationTimeoutRef.current) {
        clearTimeout(translationTimeoutRef.current);
      }

      const performTranslation = async (textValue) => {
        if (textValue.trim()) {
          const translated = await translateToMarathi(textValue);
          setFormData(prev => ({
            ...prev,
            [name]: translated // Replace original English with Marathi
          }));
        }
      };

      // If the last character is a space, translate immediately
      if (value.endsWith(' ')) {
        performTranslation(value);
      } else {
        // Otherwise, use debounce
        translationTimeoutRef.current = setTimeout(() => {
          performTranslation(value);
        }, 700);
      }
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setSelectedFiles(prev => ({
        ...prev,
        [name]: files[0]
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);

    try {
      const fileUrls = {};
      
      // Upload files to Firebase Storage
      for (const [key, file] of Object.entries(selectedFiles)) {
        if (file) {
          const fileRef = storageRef(storage, `ekamwatapzp/SocietyLotteryRegistrations/${Date.now()}_${file.name}`);
          const snapshot = await uploadBytes(fileRef, file);
          const url = await getDownloadURL(snapshot.ref);
          fileUrls[key] = url;
        }
      }

      // Combine form data with file URLs
      const finalData = {
        ...formData,
        ...fileUrls,
        status: 'pending',
        submittedAt: new Date().toISOString()
      };

      const societyRef = dbRef(db, 'ekamwatapzp/SocietyLotteryRegistrations');
      await push(societyRef, finalData);
      
      alert("संस्था लॉटरी नोंदणी आणि कागदपत्रे यशस्वीरीत्या जतन केली आहेत!");
      handleReset();
    } catch (error) {
      alert("त्रुटी: " + error.message);
    } finally {
      setUploading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      societyName: '',
      societyAddress: '',
      registrationClass: '',
      registrationNo: '',
      taluka: '',
      licenseStartDate: '',
      licenseEndDate: '',
      aadharNo: '',
      panNo: '',
      gstNo: '',
      chairmanName: '',
      chairmanWhatsapp: '',
      chairmanAddress: '',
      declaration: false
    });
    setSelectedFiles({
      aadharFile: null,
      panFile: null,
      gstFile: null,
      classificationFile: null
    });
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />
      
      <main className="flex-grow py-12 px-4">
        <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl border border-yellow-200 overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-blue-50 to-white p-8 border-b border-gray-100 text-center">
            <h1 className="text-3xl font-extrabold text-blue-900 mb-2">महाराष्ट्र शासन</h1>
            <h2 className="text-2xl font-bold text-blue-800 mb-4">सांगली जिल्हा परिषद</h2>
            <div className="inline-block px-6 py-2 bg-blue-100 text-blue-900 rounded-full font-bold text-lg">
              जुन्या मजूर सहकारी संस्थांसाठी लॉटरी चा अर्ज
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-8 md:p-12 space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <FormInput 
                label="मजूर सहकारी संस्थेचे नाव" 
                name="societyName" 
                placeholder="कृपया मजूर सहकारी संस्थेचे नाव प्रविष्ट करा." 
                required 
                value={formData.societyName}
                onChange={handleChange}
              />
              <FormInput 
                label="मजूर सहकारी संस्थेचे संपूर्ण पत्ता" 
                name="societyAddress" 
                placeholder="मजूर सहकारी संस्थेचे संपूर्ण पत्ता प्रविष्ट करा." 
                required 
                value={formData.societyAddress}
                onChange={handleChange}
              />
              <FormSelect 
                label="नोंदणीचा वर्ग" 
                name="registrationClass" 
                options={[
                  { value: 'A', label: 'अ' },
                  { value: 'B', label: 'ब' },
                  { value: 'C', label: 'क' }
                ]} 
                required 
                value={formData.registrationClass}
                onChange={handleChange}
              />
              
              <FormInput 
                label="नोंदणी क्रमांक" 
                name="registrationNo" 
                placeholder="अर्जदाराचा नोंदणी क्रमांक प्रविष्ट करा" 
                required 
                value={formData.registrationNo}
                onChange={handleChange}
              />
              <FormSelect 
                label="तालुका" 
                name="taluka" 
                options={[
                  { value: 'Miraj', label: 'मिरज' },
                  { value: 'Tasgaon', label: 'तासगाव' },
                  { value: 'Kavathe Mahankal', label: 'कवठे महांकाळ' },
                  { value: 'Walwa', label: 'वाळवा' },
                  { value: 'Shirala', label: 'शिराळा' },
                  { value: 'Khanapur', label: 'खानापूर' },
                  { value: 'Atpadi', label: 'आटपाडी' },
                  { value: 'Jat', label: 'जत' },
                  { value: 'Kadegaon', label: 'कडेगाव' },
                  { value: 'Palus', label: 'पलूस' }
                ]} 
                required 
                value={formData.taluka}
                onChange={handleChange}
              />
              <FormInput 
                label="परवानाधारक सुरुवातीची तारीख" 
                name="licenseStartDate" 
                type="date" 
                required 
                value={formData.licenseStartDate}
                onChange={handleChange}
              />

              <FormInput 
                label="परवानाधारक शेवटची तारीख" 
                name="licenseEndDate" 
                type="date" 
                required 
                value={formData.licenseEndDate}
                onChange={handleChange}
              />
              <FormInput 
                label="आधार क्रमांक" 
                name="aadharNo" 
                placeholder="आधार क्रमांक प्रविष्ट करा" 
                required 
                value={formData.aadharNo}
                onChange={handleChange}
              />
              <FormInput 
                label="पॅन क्रमांक" 
                name="panNo" 
                placeholder="पॅन क्रमांक प्रविष्ट करा" 
                required 
                value={formData.panNo}
                onChange={handleChange}
              />
            </div>

            <FormInput 
              label="जी.एस.टी क्रमांक" 
              name="gstNo" 
              placeholder="जी.एस.टी क्रमांक प्रविष्ट करा" 
              required 
              value={formData.gstNo}
              onChange={handleChange}
            />

            {/* Document Upload Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 pt-8 border-t border-gray-100">
              <FormFileUpload 
                label="आधार अपलोड (फक्त PDF अपलोड करा)" 
                name="aadharFile"
                required
                onChange={handleFileChange}
                file={selectedFiles.aadharFile}
              />
              <FormFileUpload 
                label="पॅन अपलोड (फक्त PDF अपलोड करा)" 
                name="panFile"
                required
                onChange={handleFileChange}
                file={selectedFiles.panFile}
              />
              <FormFileUpload 
                label="जी.एस.टी अपलोड (फक्त PDF अपलोड करा)" 
                name="gstFile"
                required
                onChange={handleFileChange}
                file={selectedFiles.gstFile}
              />
              <FormFileUpload 
                label="वर्गीकरण प्रमाणपत्र (फक्त PDF अपलोड करा)" 
                name="classificationFile"
                required
                onChange={handleFileChange}
                file={selectedFiles.classificationFile}
              />
              <FormInput 
                label="अर्ज करतेवेळच्या संस्थेच्या चेअरमेनचे नाव" 
                name="chairmanName" 
                placeholder="कृपया अर्ज करतेवेळच्या संस्थेच्या चेअरमेनचे नाव प्रविष्ट करा." 
                required 
                value={formData.chairmanName}
                onChange={handleChange}
              />
              <FormInput 
                label="चेअरमेन व्हॉट्सॲप नंबर" 
                name="chairmanWhatsapp" 
                type="number"
                placeholder="कृपया चेअरमेन व्हॉट्सॲप नंबर प्रविष्ट करा." 
                required 
                value={formData.chairmanWhatsapp}
                onChange={handleChange}
              />
            </div>

            <div className="w-full">
              <label className="block text-gray-700 font-bold mb-2">मजूर सहकारी संस्थेच्या चेअरमेनचा पत्ता <span className="text-red-500">*</span></label>
              <textarea 
                name="chairmanAddress"
                rows="3" 
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                placeholder="कृपया संस्थेच्या चेअरमेनचा पत्ता प्रविष्ट करा."
                required
                value={formData.chairmanAddress}
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Declaration Section */}
            <div className="bg-blue-50 p-6 rounded-xl border border-blue-100">
               <div className="flex items-start space-x-4">
                  <input 
                    type="checkbox" 
                    id="declaration" 
                    name="declaration"
                    className="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500 border-gray-300"
                    checked={formData.declaration}
                    onChange={handleChange}
                  />
                  <label htmlFor="declaration" className="text-blue-900 font-medium leading-relaxed">
                    मी प्रमाणित करतो/करते की मी एकापेक्षा जास्त नावाने कंत्राटदार म्हणून माझी नोंदणी केलेली नाही/करणार नाही.
                  </label>
               </div>
            </div>

            {/* Submit Actions */}
            <div className="flex justify-end space-x-4 pt-8">
               <button 
                  type="submit" 
                  disabled={uploading}
                  className={`${uploading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-900 hover:bg-blue-800'} text-white px-10 py-3 rounded-lg font-bold shadow-lg transition transform hover:scale-105`}
               >
                  {uploading ? 'Uploading...' : 'Submit'}
               </button>
               <button 
                  type="button" 
                  onClick={handleReset}
                  className="bg-gray-500 hover:bg-gray-600 text-white px-10 py-3 rounded-lg font-bold shadow-lg transition transform hover:scale-105"
               >
                  Reset
               </button>
            </div>
          </form>
        </div>
      </main>

      <Footer />
    </div>
  );
};

// Helper Components
const FormInput = ({ label, name, placeholder, type = "text", required = false, value, onChange }) => (
  <div className="w-full">
    <label className="block text-gray-700 font-bold mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input 
      type={type} 
      name={name}
      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
      placeholder={placeholder}
      required={required}
      value={value}
      onChange={onChange}
    />
  </div>
);

const FormSelect = ({ label, name, options, required = false, value, onChange }) => (
  <div>
    <label className="block text-gray-700 font-bold mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <select 
      name={name}
      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition bg-white"
      required={required}
      value={value}
      onChange={onChange}
    >
      <option value="">निवडा</option>
      {options.map((opt, idx) => (
        <option key={idx} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);

const FormFileUpload = ({ label, name, required = false, onChange, file }) => (
  <div>
    <label className="block text-gray-700 font-bold mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <div className="flex flex-col space-y-2">
      <label className="flex flex-col w-full h-12 border-2 border-dashed border-gray-300 rounded hover:bg-gray-100 hover:border-blue-500 transition-all cursor-pointer">
        <div className="flex items-center justify-between px-4 h-full">
          <span className="text-sm bg-gray-200 px-3 py-1 rounded text-gray-700">Choose file</span>
          <span className="text-sm text-gray-400 truncate max-w-[150px]">
            {file ? file.name : 'No file chosen'}
          </span>
        </div>
        <input 
          type="file" 
          name={name} 
          className="hidden" 
          accept=".pdf" 
          required={required && !file} 
          onChange={onChange}
        />
      </label>
      {file && (
        <button
          type="button"
          onClick={() => window.open(URL.createObjectURL(file), '_blank')}
          className="text-xs text-blue-600 hover:underline flex items-center"
        >
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          View Selected PDF
        </button>
      )}
    </div>
  </div>
);

export default SocietyLotteryRegistration;
